import Image from 'next/legacy/image'
import useDates from '@/hooks/dates'

// Assets
import Arrow from '@/assets/svg/arrow.svg'
import DoubleArrow from '@/assets/svg/switch-arrows.svg'
import TripPlaceholder from '@/assets/img/trip-placeholder.png'

// Hooks
import useTranslation from '@/hooks/translation'
import clsx from 'clsx'

function Trip({ trip, className }) {
  const { formatDate } = useDates()
  const { t } = useTranslation()

  return (
    <article
      className={clsx(
        'shadow rounded motion-safe:transition-all motion-safe:duration-100 hover:shadow-md h-full',
        className
      )}
    >
      <header className="rounded-t overflow-hidden">
        <Image
          src={TripPlaceholder}
          width={339}
          height={200}
          layout="responsive"
          objectFit="cover"
          alt=""
        />
      </header>
      <main className="bg-white rounded-b">
        <div className="p-30">
          <div className="flex items-center justify-between">
            <span className="px-5 py-3 bg-dark-5 rounded text-14 text-dark-60 leading-none mb-10 inline-block">
              {trip.isRoundtrip
                ? t('components.trip.roundtrip')
                : trip.isOneway
                ? t('components.trip.oneway')
                : trip.isMulti
                ? t('components.trip.multi')
                : null}
            </span>
            <span
              className={clsx(
                'px-5 py-3 rounded text-14 mb-10 leading-none inline-block',
                {
                  'text-success bg-green-20': trip.isActive && trip.isPast,
                  'text-primary bg-primary-20': trip.isActive && !trip.isPast,
                  'text-red bg-red-20': trip.isCancelled,
                }
              )}
            >
              {trip.isCancelled
                ? t('components.trip.cancelled')
                : trip.isPast
                ? t('components.trip.past')
                : trip.booking_status === 'schedule_change'
                ? t('components.trip.scheduleChange')
                : trip.booking_status === 'active' ||
                  trip.booking_status === 'modified'
                ? t('components.trip.active')
                : null}
            </span>
          </div>
          <div className="flex justify-between leading-none">
            <p>
              {trip.slices.map((s, i) => {
                return (
                  <span key={s.id}>
                    {formatDate(s.departureLocalDate, 'd MMM')}
                    {i < trip.slices.length - 1 ? ' - ' : null}
                  </span>
                )
              })}
            </p>
            <p>
              {t('components.trip.passengers', {
                numPassengers: trip.passengers.length,
              })}
            </p>
          </div>
          <div className="flex items-baseline text-22 font-bold">
            {trip.isOneway ? (
              <p className="flex items-baseline">
                {trip.slices[0].origin.city_name}
                <Arrow className="text-dark-60 mx-5" />
                {trip.slices[0].destination.city_name}
              </p>
            ) : trip.isRoundtrip ? (
              <p className="flex items-baseline">
                {trip.slices[0].origin.city_name}
                <DoubleArrow className="text-dark-60 mx-5" />
                {trip.slices[0].destination.city_name}
              </p>
            ) : (
              trip.slices.map((slice, i) => {
                return (
                  <p key={i} className="flex items-baseline">
                    {slice.origin.city_name}
                    {i < trip.slices.length - 1 && (
                      <Arrow className="text-dark-60 mx-5" />
                    )}
                  </p>
                )
              })
            )}
          </div>
        </div>
      </main>
    </article>
  )
}

export default Trip
